import { getRepositorySdgsRepository } from "../Infrastructure/RepositorySdgs.repository";

export async function getRepositorySdgsLogic(params) {
  return getRepositorySdgsRepository(params);
}
